import { IconButton } from "@mui/material";
import { ChevronDownIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import type React from "react";
import { useState } from "react";

type RotatingArrowButtonProps = {
  onClick: () => void;
};

const RotatingArrowButton: React.FC<RotatingArrowButtonProps> = ({ onClick }) => {
  const [rotated, setRotated] = useState(false);

  const handleClick = () => {
    setRotated((prev) => !prev);
  };

  return (
    <IconButton
      onClick={() => {
        handleClick();
        onClick();
      }}
    >
      <ChevronDownIcon
        style={{
          // otočení o 180° když rotated=true, jinak 0°
          transform: rotated ? "rotate(180deg)" : "rotate(0deg)",
          transition: "transform 0.3s ease",
        }}
        sx={{ color: "text.secondary" }}
      />
    </IconButton>
  );
};

export default RotatingArrowButton;
